{
    "meta": {
        "army_budget": 150,
        "max_army_size": 25,
        "default_ruleset": "classical"
    },
    "archetypes": {
        "swordsmen": {
            "cost": 8,
            "name": "Swordsmen",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 1000,
            "morale": 800,
            "attack": 12,
            "defense": 10,
            "armor": 3,
            "speed": 2,
            "agility": 6,
            "charge_bonus": 2,
            "bracing_bonus": 2,
            "mass": 10,
            "vision_range": 350,
            "vision_occlusion": 4,
            "symbol": "infantry",
            "ranged_attack": 12,
            "ranged_defense": 5,
            "shield": 4,
            "ammo": 1,
            "fire_range": 100,
            "fire_rate_ticks": 10,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "javelin",
            "attack_speed": 5,
            "weapon": "sword",
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "spearmen": {
            "cost": 8,
            "name": "Spearmen",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "spearmen_normal.png",
            "strength": 1000,
            "morale": 900,
            "attack": 8,
            "defense": 14,
            "armor": 4,
            "speed": 1.5,
            "agility": 4,
            "charge_bonus": 1,
            "bracing_bonus": 10,
            "mass": 12,
            "vision_range": 350,
            "vision_occlusion": 6,
            "symbol": "infantry",
            "ranged_attack": 0,
            "ranged_defense": 6,
            "shield": 5,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "spear",
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "melee_cavalry": {
            "cost": 12,
            "name": "Melee Cavalry",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "melee_cavalry_normal.png",
            "strength": 800,
            "morale": 700,
            "attack": 14,
            "defense": 8,
            "armor": 2,
            "speed": 3.5,
            "agility": 10,
            "charge_bonus": 8,
            "bracing_bonus": 0,
            "mass": 15,
            "vision_range": 400,
            "vision_occlusion": 5,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "sword",
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "shock_cavalry": {
            "cost": 14,
            "name": "Shock Cavalry",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 900,
            "morale": 600,
            "attack": 16,
            "defense": 6,
            "armor": 3,
            "speed": 3,
            "agility": 6,
            "charge_bonus": 14,
            "bracing_bonus": 0,
            "mass": 20,
            "vision_range": 400,
            "vision_occlusion": 6,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 4,
            "shield": 2,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "spear",
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "archers": {
            "cost": 10,
            "name": "Archers",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "archers_normal.png",
            "weapon": "bow",
            "strength": 100,
            "morale": 500,
            "attack": 4,
            "defense": 4,
            "armor": 1,
            "speed": 1.8,
            "agility": 5,
            "charge_bonus": 0,
            "bracing_bonus": 0,
            "mass": 6,
            "attack_speed": 7,
            "vision_range": 450,
            "vision_occlusion": 2,
            "symbol": "infantry",
            "ranged_attack": 18,
            "ranged_defense": 2,
            "shield": 0,
            "ammo": 35,
            "fire_range": 450,
            "fire_rate_ticks": 40,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 6,
            "projectile_type": "arrow",
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "horse_archers": {
            "cost": 12,
            "name": "Horse Archers",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "horse_archers_normal.png",
            "strength": 500,
            "morale": 500,
            "attack": 6,
            "defense": 5,
            "armor": 1,
            "speed": 3.5,
            "agility": 10,
            "charge_bonus": 1,
            "bracing_bonus": 0,
            "mass": 12,
            "vision_range": 400,
            "vision_occlusion": 2.5,
            "symbol": "cavalry",
            "ranged_attack": 10,
            "ranged_defense": 2,
            "shield": 0,
            "ammo": 22,
            "fire_range": 300,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45,
            "projectile_count": 5,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "weapon": "bow",
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "skirmishers": {
            "cost": 9,
            "name": "Skirmishers",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "skirmishers_normal.png",
            "strength": 700,
            "morale": 600,
            "attack": 8,
            "defense": 6,
            "armor": 2,
            "speed": 2.5,
            "agility": 8,
            "charge_bonus": 1,
            "bracing_bonus": 0,
            "mass": 8,
            "vision_range": 350,
            "vision_occlusion": 1.5,
            "symbol": "infantry",
            "ranged_attack": 20,
            "ranged_defense": 3,
            "shield": 2,
            "ammo": 15,
            "fire_range": 200,
            "fire_rate_ticks": 50,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45,
            "projectile_count": 5,
            "projectile_type": "javelin",
            "attack_speed": 5,
            "weapon": "axe",
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "line_infantry": {
            "cost": 9,
            "name": "Line Infantry",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:hollow_square"
            ],
            "sprite": "line_infantry_normal.png",
            "strength": 800,
            "morale": 750,
            "attack": 5,
            "defense": 6,
            "armor": 1,
            "speed": 1.7,
            "agility": 4,
            "charge_bonus": 1,
            "bracing_bonus": 4,
            "mass": 9,
            "vision_range": 350,
            "vision_occlusion": 6,
            "symbol": "infantry",
            "ranged_attack": 18,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 60,
            "fire_range": 280,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.7,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "light_infantry": {
            "cost": 9,
            "name": "Light Infantry",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:open_order"
            ],
            "sprite": "light_infantry_normal.png",
            "strength": 700,
            "morale": 700,
            "attack": 6,
            "defense": 6,
            "armor": 1,
            "speed": 2.3,
            "agility": 7,
            "charge_bonus": 2,
            "bracing_bonus": 2,
            "mass": 8,
            "vision_range": 380,
            "vision_occlusion": 4,
            "symbol": "infantry",
            "ranged_attack": 14,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 60,
            "fire_range": 260,
            "fire_rate_ticks": 30,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "voltigeurs": {
            "cost": 9,
            "name": "Voltigeurs",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:open_order"
            ],
            "sprite": "light_infantry_normal.png",
            "strength": 600,
            "morale": 600,
            "attack": 7,
            "defense": 5,
            "armor": 1,
            "speed": 2.6,
            "agility": 9,
            "charge_bonus": 1,
            "bracing_bonus": 0,
            "mass": 7,
            "vision_range": 380,
            "vision_occlusion": 2,
            "symbol": "infantry",
            "ranged_attack": 14,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 30,
            "fire_range": 270,
            "fire_rate_ticks": 25,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60,
            "projectile_count": 3,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "riflemen": {
            "cost": 12,
            "name": "Riflemen",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:open_order"
            ],
            "sprite": "light_infantry_normal.png",
            "strength": 500,
            "morale": 700,
            "attack": 6,
            "defense": 5,
            "armor": 1,
            "speed": 2.2,
            "agility": 8,
            "charge_bonus": 1,
            "bracing_bonus": 0,
            "mass": 7,
            "vision_range": 450,
            "vision_occlusion": 4,
            "symbol": "infantry",
            "ranged_attack": 22,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 28,
            "fire_range": 380,
            "fire_rate_ticks": 55,
            "ranged_accuracy": 0.85,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 3,
            "projectile_type": "rifle_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "grenadiers": {
            "cost": 13,
            "name": "Grenadiers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:hollow_square"
            ],
            "sprite": "line_infantry_normal.png",
            "strength": 950,
            "morale": 900,
            "attack": 9,
            "defense": 9,
            "armor": 2,
            "speed": 1.7,
            "agility": 5,
            "charge_bonus": 3,
            "bracing_bonus": 5,
            "mass": 11,
            "vision_range": 350,
            "vision_occlusion": 6,
            "symbol": "infantry",
            "ranged_attack": 18,
            "ranged_defense": 5,
            "shield": 0,
            "ammo": 60,
            "fire_range": 280,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "dragoons": {
            "cost": 13,
            "name": "Dragoons",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "hussars_normal.png",
            "strength": 700,
            "morale": 700,
            "attack": 12,
            "defense": 8,
            "armor": 2,
            "speed": 3.6,
            "agility": 9,
            "charge_bonus": 6,
            "bracing_bonus": 0,
            "mass": 14,
            "vision_range": 400,
            "vision_occlusion": 5,
            "symbol": "cavalry",
            "ranged_attack": 12,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 22,
            "fire_range": 200,
            "fire_rate_ticks": 40,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60,
            "projectile_count": 4,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "lancers": {
            "cost": 15,
            "name": "Lancers",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:wedge"
            ],
            "sprite": "hussars_normal.png",
            "strength": 850,
            "morale": 700,
            "attack": 14,
            "defense": 7,
            "armor": 2,
            "speed": 3.4,
            "agility": 8,
            "charge_bonus": 18,
            "bracing_bonus": 0,
            "mass": 18,
            "vision_range": 400,
            "vision_occlusion": 5,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "foot_artillery": {
            "cost": 18,
            "name": "Foot Artillery",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "foot_artillery_normal.png",
            "weapon": null,
            "strength": 350.0,
            "morale": 500.0,
            "troops": 24,
            "formation_kind": "equipment",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25,
            "attack": 2.0,
            "defense": 3.0,
            "armor": 4.0,
            "speed": 0.5,
            "agility": 1.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 50.0,
            "attack_speed": 5,
            "vision_range": 500.0,
            "vision_occlusion": 3.0,
            "symbol": "siege",
            "ranged_attack": 30.0,
            "ranged_defense": 4.0,
            "shield": 0.0,
            "ammo": 250,
            "fire_range": 700.0,
            "fire_rate_ticks": 70,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25.0,
            "projectile_count": 1,
            "projectile_type": "cannonball",
            "artillery": {
                "gun_count": 4,
                "crew_per_gun": 6,
                "horses_per_gun": 4,
                "gun_spacing_m": 10,
                "limber_ticks": 30,
                "unlimber_ticks": 30,
                "aim_ticks": 10,
                "crew_move_speed": 0.15,
                "gun_length_m": 3,
                "gun_width_m": 2,
                "crew_radius_m": 2,
                "muzzle_height_m": 1.2,
                "crew_height_m": 2,
                "obstacle_height_m": 8,
                "legacy_height_step_m": 10,
                "round_shot_speed_mps": 600,
                "shell_speed_mps": 120,
                "canister_range_m": 150,
                "canister_samples": 24,
                "canister_spread_degrees": 12,
                "shell_blast_radius_m": 20,
                "shell_burst_jitter_m": 20,
                "shell_impact_delay_seconds": 2,
                "gravity_mps2": 9.81,
                "canister_damage_multiplier": 1,
                "shell_damage_multiplier": 1,
                "supported_modes": [
                    "direct"
                ],
                "supported_ammunition": [
                    "round_shot",
                    "canister"
                ]
            }
        },
        "horse_artillery": {
            "cost": 20,
            "name": "Horse Artillery",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "foot_artillery_normal.png",
            "weapon": null,
            "strength": 300.0,
            "morale": 550.0,
            "troops": 24,
            "formation_kind": "equipment",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25,
            "attack": 2.0,
            "defense": 3.0,
            "armor": 3.0,
            "speed": 2.2,
            "agility": 4.0,
            "charge_bonus": 0.0,
            "bracing_bonus": 0.0,
            "mass": 35.0,
            "attack_speed": 5,
            "vision_range": 500.0,
            "vision_occlusion": 3.0,
            "symbol": "siege",
            "ranged_attack": 26.0,
            "ranged_defense": 3.0,
            "shield": 0.0,
            "ammo": 220,
            "fire_range": 600.0,
            "fire_rate_ticks": 75,
            "ranged_accuracy": 0.62,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25.0,
            "projectile_count": 1,
            "projectile_type": "cannonball",
            "artillery": {
                "gun_count": 4,
                "crew_per_gun": 6,
                "horses_per_gun": 4,
                "gun_spacing_m": 10,
                "limber_ticks": 30,
                "unlimber_ticks": 30,
                "aim_ticks": 10,
                "crew_move_speed": 0.15,
                "gun_length_m": 3,
                "gun_width_m": 2,
                "crew_radius_m": 2,
                "muzzle_height_m": 1.2,
                "crew_height_m": 2,
                "obstacle_height_m": 8,
                "legacy_height_step_m": 10,
                "round_shot_speed_mps": 600,
                "shell_speed_mps": 120,
                "canister_range_m": 150,
                "canister_samples": 24,
                "canister_spread_degrees": 12,
                "shell_blast_radius_m": 20,
                "shell_burst_jitter_m": 20,
                "shell_impact_delay_seconds": 2,
                "gravity_mps2": 9.81,
                "canister_damage_multiplier": 1,
                "shell_damage_multiplier": 1,
                "supported_modes": [
                    "direct"
                ],
                "supported_ammunition": [
                    "round_shot",
                    "canister"
                ]
            }
        },
        "howitzer": {
            "cost": 18,
            "name": "Howitzer",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "foot_artillery_normal.png",
            "strength": 350,
            "morale": 500,
            "attack": 2,
            "defense": 3,
            "armor": 4,
            "speed": 0.5,
            "agility": 1,
            "charge_bonus": 0,
            "bracing_bonus": 0,
            "mass": 50,
            "vision_range": 500,
            "vision_occlusion": 3,
            "symbol": "siege",
            "ranged_attack": 30,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 25,
            "fire_range": 700,
            "fire_rate_ticks": 70,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25,
            "projectile_count": 1,
            "projectile_type": "shell",
            "attack_speed": 5,
            "troops": 24,
            "formation_kind": "equipment",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25,
            "artillery": {
                "gun_count": 4,
                "crew_per_gun": 6,
                "horses_per_gun": 4,
                "gun_spacing_m": 10,
                "limber_ticks": 30,
                "unlimber_ticks": 30,
                "aim_ticks": 10,
                "crew_move_speed": 0.15,
                "gun_length_m": 3,
                "gun_width_m": 2,
                "crew_radius_m": 2,
                "muzzle_height_m": 1.2,
                "crew_height_m": 2,
                "obstacle_height_m": 8,
                "legacy_height_step_m": 10,
                "round_shot_speed_mps": 600,
                "shell_speed_mps": 120,
                "canister_range_m": 150,
                "canister_samples": 24,
                "canister_spread_degrees": 12,
                "shell_blast_radius_m": 20,
                "shell_burst_jitter_m": 20,
                "shell_impact_delay_seconds": 2,
                "gravity_mps2": 9.81,
                "canister_damage_multiplier": 1,
                "shell_damage_multiplier": 1,
                "supported_modes": [
                    "direct",
                    "indirect"
                ],
                "supported_ammunition": [
                    "shell",
                    "canister"
                ]
            }
        },
        "mortar": {
            "cost": 18,
            "name": "Mortar",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "foot_artillery_normal.png",
            "strength": 350,
            "morale": 500,
            "attack": 2,
            "defense": 3,
            "armor": 4,
            "speed": 0.5,
            "agility": 1,
            "charge_bonus": 0,
            "bracing_bonus": 0,
            "mass": 50,
            "vision_range": 500,
            "vision_occlusion": 3,
            "symbol": "siege",
            "ranged_attack": 30,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 25,
            "fire_range": 700,
            "fire_rate_ticks": 70,
            "ranged_accuracy": 0.65,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25,
            "projectile_count": 1,
            "projectile_type": "shell",
            "attack_speed": 5,
            "troops": 24,
            "formation_kind": "equipment",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25,
            "artillery": {
                "gun_count": 4,
                "crew_per_gun": 6,
                "horses_per_gun": 4,
                "gun_spacing_m": 10,
                "limber_ticks": 30,
                "unlimber_ticks": 30,
                "aim_ticks": 10,
                "crew_move_speed": 0.15,
                "gun_length_m": 3,
                "gun_width_m": 2,
                "crew_radius_m": 2,
                "muzzle_height_m": 1.2,
                "crew_height_m": 2,
                "obstacle_height_m": 8,
                "legacy_height_step_m": 10,
                "round_shot_speed_mps": 600,
                "shell_speed_mps": 120,
                "canister_range_m": 150,
                "canister_samples": 24,
                "canister_spread_degrees": 12,
                "shell_blast_radius_m": 20,
                "shell_burst_jitter_m": 20,
                "shell_impact_delay_seconds": 2,
                "gravity_mps2": 9.81,
                "canister_damage_multiplier": 1,
                "shell_damage_multiplier": 1,
                "supported_modes": [
                    "indirect"
                ],
                "supported_ammunition": [
                    "shell"
                ]
            }
        },
        "militia": {
            "cost": 5,
            "name": "Militia",
            "category": "infantry",
            "ruleset": "napoleonic",
            "sprite": "line_infantry_normal.png",
            "strength": 600,
            "morale": 400,
            "attack": 4,
            "defense": 4,
            "armor": 0,
            "speed": 1.6,
            "agility": 4,
            "charge_bonus": 0,
            "bracing_bonus": 1,
            "mass": 8,
            "vision_range": 300,
            "vision_occlusion": 3,
            "symbol": "infantry",
            "ranged_attack": 12,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 60,
            "fire_range": 220,
            "fire_rate_ticks": 50,
            "ranged_accuracy": 0.55,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "guard_infantry": {
            "cost": 16,
            "name": "Guard Infantry",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:hollow_square"
            ],
            "sprite": "line_infantry_normal.png",
            "strength": 1000,
            "morale": 1000,
            "attack": 11,
            "defense": 11,
            "armor": 3,
            "speed": 1.8,
            "agility": 6,
            "charge_bonus": 4,
            "bracing_bonus": 6,
            "mass": 11,
            "vision_range": 380,
            "vision_occlusion": 7,
            "symbol": "infantry",
            "ranged_attack": 20,
            "ranged_defense": 6,
            "shield": 0,
            "ammo": 60,
            "fire_range": 290,
            "fire_rate_ticks": 32,
            "ranged_accuracy": 0.78,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "legionaries": {
            "cost": 12,
            "name": "Legionaries",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 1100,
            "morale": 900,
            "attack": 13,
            "defense": 12,
            "armor": 5,
            "speed": 2,
            "agility": 6,
            "charge_bonus": 3,
            "bracing_bonus": 4,
            "mass": 11,
            "vision_range": 350,
            "vision_occlusion": 5,
            "symbol": "infantry",
            "ranged_attack": 14,
            "ranged_defense": 6,
            "shield": 6,
            "ammo": 1,
            "fire_range": 110,
            "fire_rate_ticks": 10,
            "ranged_accuracy": 0.85,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "javelin",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "praetorian_guard": {
            "cost": 16,
            "name": "Praetorian Guard",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 1000,
            "morale": 1100,
            "attack": 16,
            "defense": 13,
            "armor": 6,
            "speed": 2,
            "agility": 7,
            "charge_bonus": 4,
            "bracing_bonus": 5,
            "mass": 12,
            "vision_range": 380,
            "vision_occlusion": 5,
            "symbol": "infantry",
            "ranged_attack": 14,
            "ranged_defense": 7,
            "shield": 7,
            "ammo": 1,
            "fire_range": 110,
            "fire_rate_ticks": 10,
            "ranged_accuracy": 0.9,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "javelin",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "naked_fanatics": {
            "cost": 7,
            "name": "Naked Fanatics",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "swordsmen_normal.png",
            "strength": 900,
            "morale": 1000,
            "attack": 16,
            "defense": 5,
            "armor": 0,
            "speed": 2.6,
            "agility": 9,
            "charge_bonus": 8,
            "bracing_bonus": 0,
            "mass": 9,
            "vision_range": 350,
            "vision_occlusion": 3,
            "symbol": "infantry",
            "ranged_attack": 0,
            "ranged_defense": 2,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "war_chariot": {
            "cost": 14,
            "name": "War Chariot",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 700,
            "morale": 700,
            "attack": 12,
            "defense": 6,
            "armor": 3,
            "speed": 3.4,
            "agility": 7,
            "charge_bonus": 12,
            "bracing_bonus": 0,
            "mass": 22,
            "vision_range": 400,
            "vision_occlusion": 6,
            "symbol": "cavalry",
            "ranged_attack": 10,
            "ranged_defense": 3,
            "shield": 2,
            "ammo": 8,
            "fire_range": 180,
            "fire_rate_ticks": 30,
            "ranged_accuracy": 0.6,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60,
            "projectile_count": 2,
            "projectile_type": "javelin",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "equipment",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "sacred_band": {
            "cost": 13,
            "name": "Sacred Band",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "spearmen_normal.png",
            "strength": 1000,
            "morale": 1100,
            "attack": 11,
            "defense": 16,
            "armor": 5,
            "speed": 1.6,
            "agility": 5,
            "charge_bonus": 2,
            "bracing_bonus": 12,
            "mass": 13,
            "vision_range": 360,
            "vision_occlusion": 6,
            "symbol": "infantry",
            "ranged_attack": 0,
            "ranged_defense": 7,
            "shield": 7,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "war_elephant": {
            "cost": 20,
            "name": "War Elephant",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 600,
            "morale": 800,
            "attack": 18,
            "defense": 8,
            "armor": 6,
            "speed": 2.4,
            "agility": 4,
            "charge_bonus": 18,
            "bracing_bonus": 0,
            "mass": 60,
            "vision_range": 400,
            "vision_occlusion": 8,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 5,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "equipment",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "immortals": {
            "cost": 13,
            "name": "Immortals",
            "category": "infantry",
            "ruleset": "classical",
            "sprite": "spearmen_normal.png",
            "strength": 1000,
            "morale": 1000,
            "attack": 11,
            "defense": 13,
            "armor": 4,
            "speed": 1.9,
            "agility": 6,
            "charge_bonus": 2,
            "bracing_bonus": 8,
            "mass": 11,
            "vision_range": 380,
            "vision_occlusion": 5,
            "symbol": "infantry",
            "ranged_attack": 13,
            "ranged_defense": 5,
            "shield": 5,
            "ammo": 24,
            "fire_range": 380,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.78,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 4,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "scythed_chariot": {
            "cost": 14,
            "name": "Scythed Chariot",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 500,
            "morale": 600,
            "attack": 10,
            "defense": 5,
            "armor": 3,
            "speed": 3.6,
            "agility": 5,
            "charge_bonus": 22,
            "bracing_bonus": 0,
            "mass": 25,
            "vision_range": 380,
            "vision_occlusion": 6,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "equipment",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "heavy_horse_archers": {
            "cost": 14,
            "name": "Heavy Horse Archers",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "horse_archers_normal.png",
            "strength": 600,
            "morale": 600,
            "attack": 8,
            "defense": 7,
            "armor": 3,
            "speed": 3.4,
            "agility": 9,
            "charge_bonus": 2,
            "bracing_bonus": 0,
            "mass": 14,
            "vision_range": 420,
            "vision_occlusion": 3,
            "symbol": "cavalry",
            "ranged_attack": 13,
            "ranged_defense": 3,
            "shield": 1,
            "ammo": 28,
            "fire_range": 340,
            "fire_rate_ticks": 32,
            "ranged_accuracy": 0.72,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 45,
            "projectile_count": 5,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "kontos_lancers": {
            "cost": 15,
            "name": "Kontos Lancers",
            "category": "cavalry",
            "ruleset": "classical",
            "sprite": "shock_cavalry_normal.png",
            "strength": 700,
            "morale": 700,
            "attack": 14,
            "defense": 8,
            "armor": 4,
            "speed": 3.2,
            "agility": 7,
            "charge_bonus": 16,
            "bracing_bonus": 0,
            "mass": 20,
            "vision_range": 400,
            "vision_occlusion": 6,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 4,
            "shield": 2,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "cuirassiers": {
            "cost": 16,
            "name": "Cuirassiers",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "hussars_normal.png",
            "strength": 800,
            "morale": 850,
            "attack": 15,
            "defense": 10,
            "armor": 5,
            "speed": 3.2,
            "agility": 7,
            "charge_bonus": 14,
            "bracing_bonus": 0,
            "mass": 22,
            "vision_range": 400,
            "vision_occlusion": 6,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 5,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "old_guard": {
            "cost": 18,
            "name": "Old Guard",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:hollow_square"
            ],
            "sprite": "line_infantry_normal.png",
            "strength": 1000,
            "morale": 1100,
            "attack": 12,
            "defense": 12,
            "armor": 3,
            "speed": 1.9,
            "agility": 6,
            "charge_bonus": 5,
            "bracing_bonus": 7,
            "mass": 11,
            "vision_range": 380,
            "vision_occlusion": 7,
            "symbol": "infantry",
            "ranged_attack": 22,
            "ranged_defense": 7,
            "shield": 0,
            "ammo": 60,
            "fire_range": 300,
            "fire_rate_ticks": 30,
            "ranged_accuracy": 0.82,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "highlanders": {
            "cost": 12,
            "name": "Highlanders",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:hollow_square"
            ],
            "sprite": "line_infantry_normal.png",
            "strength": 900,
            "morale": 950,
            "attack": 12,
            "defense": 8,
            "armor": 1,
            "speed": 2,
            "agility": 7,
            "charge_bonus": 6,
            "bracing_bonus": 3,
            "mass": 10,
            "vision_range": 360,
            "vision_occlusion": 6,
            "symbol": "infantry",
            "ranged_attack": 18,
            "ranged_defense": 5,
            "shield": 0,
            "ammo": 60,
            "fire_range": 280,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.74,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "rocket_battery": {
            "cost": 16,
            "name": "Rocket Battery",
            "category": "siege",
            "ruleset": "napoleonic",
            "sprite": "foot_artillery_normal.png",
            "strength": 300,
            "morale": 500,
            "attack": 2,
            "defense": 3,
            "armor": 2,
            "speed": 1,
            "agility": 2,
            "charge_bonus": 0,
            "bracing_bonus": 0,
            "mass": 28,
            "vision_range": 500,
            "vision_occlusion": 3,
            "symbol": "siege",
            "ranged_attack": 28,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 18,
            "fire_range": 800,
            "fire_rate_ticks": 60,
            "ranged_accuracy": 0.35,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25,
            "projectile_count": 1,
            "projectile_type": "boulder",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "equipment",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "cossacks": {
            "cost": 11,
            "name": "Cossacks",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "sprite": "hussars_normal.png",
            "strength": 600,
            "morale": 700,
            "attack": 10,
            "defense": 7,
            "armor": 1,
            "speed": 3.8,
            "agility": 10,
            "charge_bonus": 6,
            "bracing_bonus": 0,
            "mass": 12,
            "vision_range": 420,
            "vision_occlusion": 4,
            "symbol": "cavalry",
            "ranged_attack": 10,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 18,
            "fire_range": 200,
            "fire_rate_ticks": 38,
            "ranged_accuracy": 0.6,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60,
            "projectile_count": 3,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "pavlov_grenadiers": {
            "cost": 15,
            "name": "Pavlov Grenadiers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:hollow_square"
            ],
            "sprite": "line_infantry_normal.png",
            "strength": 1000,
            "morale": 1000,
            "attack": 10,
            "defense": 11,
            "armor": 3,
            "speed": 1.6,
            "agility": 5,
            "charge_bonus": 5,
            "bracing_bonus": 7,
            "mass": 12,
            "vision_range": 350,
            "vision_occlusion": 7,
            "symbol": "infantry",
            "ranged_attack": 19,
            "ranged_defense": 6,
            "shield": 0,
            "ammo": 60,
            "fire_range": 280,
            "fire_rate_ticks": 35,
            "ranged_accuracy": 0.74,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 6,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "jaegers": {
            "cost": 14,
            "name": "Jaegers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:open_order"
            ],
            "sprite": "light_infantry_normal.png",
            "strength": 550,
            "morale": 800,
            "attack": 7,
            "defense": 6,
            "armor": 1,
            "speed": 2.4,
            "agility": 9,
            "charge_bonus": 1,
            "bracing_bonus": 0,
            "mass": 7,
            "vision_range": 470,
            "vision_occlusion": 4,
            "symbol": "infantry",
            "ranged_attack": 24,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 30,
            "fire_range": 400,
            "fire_rate_ticks": 50,
            "ranged_accuracy": 0.88,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 30,
            "projectile_count": 3,
            "projectile_type": "rifle_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "uhlans": {
            "cost": 14,
            "name": "Uhlans",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:wedge"
            ],
            "sprite": "hussars_normal.png",
            "strength": 800,
            "morale": 750,
            "attack": 13,
            "defense": 7,
            "armor": 2,
            "speed": 3.5,
            "agility": 8,
            "charge_bonus": 16,
            "bracing_bonus": 0,
            "mass": 17,
            "vision_range": 400,
            "vision_occlusion": 5,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "grenzers": {
            "cost": 10,
            "name": "Grenzers",
            "category": "infantry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:open_order"
            ],
            "sprite": "light_infantry_normal.png",
            "strength": 650,
            "morale": 700,
            "attack": 7,
            "defense": 6,
            "armor": 1,
            "speed": 2.4,
            "agility": 8,
            "charge_bonus": 1,
            "bracing_bonus": 1,
            "mass": 7,
            "vision_range": 400,
            "vision_occlusion": 3,
            "symbol": "infantry",
            "ranged_attack": 16,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 40,
            "fire_range": 290,
            "fire_rate_ticks": 28,
            "ranged_accuracy": 0.75,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60,
            "projectile_count": 4,
            "projectile_type": "musket_ball",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "hussars": {
            "cost": 11,
            "name": "Hussars",
            "category": "cavalry",
            "ruleset": "napoleonic",
            "formation_tags": [
                "drill:wedge"
            ],
            "sprite": "hussars_normal.png",
            "strength": 600,
            "morale": 750,
            "attack": 11,
            "defense": 7,
            "armor": 1,
            "speed": 3.7,
            "agility": 10,
            "charge_bonus": 8,
            "bracing_bonus": 0,
            "mass": 13,
            "vision_range": 420,
            "vision_occlusion": 4,
            "symbol": "cavalry",
            "ranged_attack": 0,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 0,
            "fire_range": 0,
            "fire_rate_ticks": 0,
            "ranged_accuracy": 0,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 45,
            "projectile_count": 1,
            "projectile_type": "arrow",
            "attack_speed": 5,
            "troops": 200,
            "formation_kind": "ranked",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        },
        "ww2_rifleman": {
            "cost": 5,
            "squad_size": 4,
            "name": "Rifleman",
            "category": "infantry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 100,
            "morale": 700,
            "attack": 1,
            "defense": 2,
            "armor": 0,
            "speed": 2,
            "agility": 6,
            "charge_bonus": 0,
            "bracing_bonus": 1,
            "mass": 1,
            "vision_range": 400,
            "vision_occlusion": 0.5,
            "symbol": "infantry",
            "ranged_attack": 14,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 120,
            "fire_range": 350,
            "fire_rate_ticks": 8,
            "ranged_accuracy": 0.75,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 60,
            "projectile_count": 1,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "penetration": 0,
            "suppression_power": 1,
            "troops": 200,
            "formation_kind": "individual",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "ww2_mg_team": {
            "cost": 9,
            "squad_size": 2,
            "name": "MG Team",
            "category": "infantry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 120,
            "morale": 700,
            "attack": 1,
            "defense": 2,
            "armor": 0,
            "speed": 1.3,
            "agility": 3,
            "charge_bonus": 0,
            "bracing_bonus": 3,
            "mass": 2,
            "vision_range": 400,
            "vision_occlusion": 0.5,
            "symbol": "infantry",
            "ranged_attack": 28,
            "ranged_defense": 4,
            "shield": 0,
            "ammo": 200,
            "fire_range": 450,
            "fire_rate_ticks": 3,
            "ranged_accuracy": 0.55,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 25,
            "projectile_count": 6,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "penetration": 0,
            "suppression_power": 2.5,
            "troops": 200,
            "formation_kind": "individual",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "ww2_mortar": {
            "cost": 11,
            "squad_size": 3,
            "name": "Mortar Team",
            "category": "infantry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 90,
            "morale": 650,
            "attack": 1,
            "defense": 1,
            "armor": 0,
            "speed": 1.2,
            "agility": 3,
            "charge_bonus": 0,
            "bracing_bonus": 0,
            "mass": 2,
            "vision_range": 350,
            "vision_occlusion": 0.5,
            "symbol": "infantry",
            "ranged_attack": 45,
            "ranged_defense": 3,
            "shield": 0,
            "ammo": 30,
            "fire_range": 700,
            "fire_rate_ticks": 40,
            "ranged_accuracy": 0.6,
            "can_fire_while_moving": false,
            "fire_arc_half_angle": 180,
            "projectile_count": 1,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "penetration": 0,
            "indirect_fire": true,
            "splash_radius": 90,
            "min_range": 150,
            "suppression_power": 4,
            "troops": 200,
            "formation_kind": "individual",
            "soldier_frontage_m": 1.25,
            "soldier_rank_depth_m": 1.25
        },
        "ww2_medium_tank": {
            "cost": 20,
            "squad_size": 1,
            "name": "Medium Tank",
            "category": "cavalry",
            "ruleset": "ww2",
            "sprite": null,
            "strength": 600,
            "morale": 900,
            "attack": 4,
            "defense": 8,
            "armor": 12,
            "speed": 3,
            "agility": 4,
            "charge_bonus": 0,
            "bracing_bonus": 0,
            "mass": 40,
            "vision_range": 450,
            "vision_occlusion": 4,
            "symbol": "cavalry",
            "ranged_attack": 60,
            "ranged_defense": 18,
            "shield": 0,
            "ammo": 40,
            "fire_range": 500,
            "fire_rate_ticks": 25,
            "ranged_accuracy": 0.8,
            "can_fire_while_moving": true,
            "fire_arc_half_angle": 180,
            "projectile_count": 1,
            "projectile_type": "rifle_ball",
            "attack_speed": 1,
            "armor_front": 12,
            "armor_side": 8,
            "armor_rear": 4,
            "penetration": 14,
            "suppression_power": 3,
            "is_vehicle": true,
            "troops": 200,
            "formation_kind": "individual",
            "soldier_frontage_m": 2,
            "soldier_rank_depth_m": 3
        }
    },
    "custom_units": {
        "rulesets": {
            "classical": {
                "visual_archetype": "swordsmen",
                "base": {
                    "cost": 6,
                    "name": "Population Levy",
                    "category": "infantry",
                    "symbol": "infantry",
                    "strength": 750,
                    "morale": 550,
                    "quality_tier": 1,
                    "shock_resistance": 0.05,
                    "attack": 5,
                    "defense": 5,
                    "armor": 0,
                    "speed": 2,
                    "agility": 5,
                    "charge_bonus": 0,
                    "bracing_bonus": 1,
                    "mass": 8,
                    "vision_range": 350,
                    "vision_occlusion": 3,
                    "ranged_attack": 0,
                    "ranged_defense": 1,
                    "shield": 0,
                    "ammo": 0,
                    "fire_range": 0,
                    "fire_rate_ticks": 0,
                    "ranged_accuracy": 0,
                    "can_fire_while_moving": false,
                    "fire_arc_half_angle": 45,
                    "projectile_count": 1,
                    "projectile_type": "arrow",
                    "troops": 180,
                    "formation_kind": "ranked",
                    "soldier_frontage_m": 1.25,
                    "soldier_rank_depth_m": 1.25
                },
                "melee_weapons": {
                    "club": {
                        "name": "Club",
                        "cost": 0
                    },
                    "gladius": {
                        "name": "Gladius",
                        "attack": 3,
                        "defense": -1,
                        "cost": 2
                    },
                    "spear": {
                        "name": "Spear",
                        "attack": 1,
                        "defense": 2,
                        "bracing_bonus": 5,
                        "speed": -0.1,
                        "cost": 2
                    },
                    "two_handed_axe": {
                        "name": "Two-Handed Axe",
                        "attack": 4,
                        "defense": -2,
                        "cost": 2,
                        "two_handed": true,
                        "blocks_shield": true
                    }
                },
                "shields": {
                    "none": {
                        "name": "No Shield",
                        "cost": 0
                    },
                    "small": {
                        "name": "Small Shield",
                        "defense": 1,
                        "ranged_defense": 2,
                        "shield": 2,
                        "speed": -0.05,
                        "cost": 1
                    },
                    "large": {
                        "name": "Large Shield",
                        "defense": 2,
                        "ranged_defense": 4,
                        "shield": 5,
                        "speed": -0.25,
                        "vision_range": -50,
                        "cost": 2
                    }
                },
                "armor": {
                    "none": {
                        "name": "No Armor",
                        "cost": 0
                    },
                    "padded": {
                        "name": "Padded Armor",
                        "armor": 1,
                        "ranged_defense": 1,
                        "speed": -0.05,
                        "cost": 1
                    },
                    "mail": {
                        "name": "Mail Armor",
                        "armor": 3,
                        "ranged_defense": 2,
                        "speed": -0.2,
                        "agility": -1,
                        "cost": 3
                    },
                    "heavy": {
                        "name": "Heavy Armor",
                        "armor": 5,
                        "ranged_defense": 3,
                        "speed": -0.4,
                        "agility": -2,
                        "cost": 5
                    }
                },
                "ranged_weapons": {
                    "none": {
                        "name": "No Ranged Weapon",
                        "cost": 0
                    },
                    "javelins": {
                        "name": "Javelins",
                        "ranged_attack": 8,
                        "ammo": 10,
                        "fire_range": 180,
                        "fire_rate_ticks": 45,
                        "ranged_accuracy": 0.7,
                        "projectile_count": 4,
                        "projectile_type": "javelin",
                        "cost": 2
                    },
                    "bow": {
                        "name": "Bow",
                        "ranged_attack": 12,
                        "ammo": 30,
                        "fire_range": 420,
                        "fire_rate_ticks": 45,
                        "ranged_accuracy": 0.72,
                        "projectile_count": 5,
                        "projectile_type": "arrow",
                        "cost": 4,
                        "blocks_shield": true
                    }
                },
                "mounts": {
                    "none": {
                        "name": "No Mount",
                        "cost": 0
                    },
                    "horse": {
                        "name": "Horse",
                        "category": "cavalry",
                        "symbol": "cavalry",
                        "speed": 1.2,
                        "agility": 3,
                        "charge_bonus": 4,
                        "mass": 5,
                        "strength": -100,
                        "vision_range": 50,
                        "troops": 80,
                        "cost": 4,
                        "formation_kind": "ranked",
                        "soldier_frontage_m": 2,
                        "soldier_rank_depth_m": 3
                    }
                },
                "training_tracks": {
                    "weapon": {
                        "name": "Weapon Drill",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "melee_weapon"
                        ],
                        "rank_10": {
                            "attack": 5
                        }
                    },
                    "shield": {
                        "name": "Shield Drill",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "shield"
                        ],
                        "rank_10": {
                            "ranged_defense": 5,
                            "shield": 3
                        }
                    },
                    "formation": {
                        "name": "Formation Discipline",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "always"
                        ],
                        "rank_10": {
                            "defense": 3,
                            "bracing_bonus": 2,
                            "morale": 60
                        }
                    },
                    "endurance": {
                        "name": "Endurance",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "always"
                        ],
                        "rank_10": {
                            "fatigue_buildup_multiplier": 0.7,
                            "fatigue_recovery_multiplier": 1.3
                        }
                    },
                    "skirmishing": {
                        "name": "Skirmishing",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "ranged_weapon"
                        ],
                        "rank_10": {
                            "ranged_accuracy": 0.15
                        }
                    },
                    "horsemanship": {
                        "name": "Horsemanship",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "mount"
                        ],
                        "rank_10": {
                            "speed": 0.25,
                            "agility": 2,
                            "charge_bonus": 3
                        }
                    },
                    "fieldcraft": {
                        "name": "Fieldcraft",
                        "max_rank": 10,
                        "cost_per_rank": 1,
                        "applies_to": [
                            "always"
                        ],
                        "rank_10": {
                            "vision_range": 100,
                            "speed": 0.15
                        }
                    }
                },
                "culture_modifiers": {
                    "roman": {
                        "name": "Roman Drill",
                        "default": {
                            "attack": 1
                        }
                    },
                    "gaul": {
                        "name": "Gallic Defiance",
                        "default": {
                            "defense": 1,
                            "morale": 50,
                            "shock_resistance": 0.02
                        }
                    },
                    "carthaginian": {
                        "name": "Punic Spear Schools",
                        "default": {
                            "bracing_bonus": 1
                        },
                        "spear": {
                            "defense": 1,
                            "bracing_bonus": 3
                        }
                    },
                    "persian": {
                        "name": "Persian Horsemanship",
                        "default": {
                            "agility": 1
                        },
                        "mounted": {
                            "speed": 0.15,
                            "charge_bonus": 2
                        }
                    },
                    "steppe": {
                        "name": "Steppe Riding",
                        "default": {
                            "agility": 1
                        },
                        "mounted_ranged": {
                            "speed": 0.15,
                            "ranged_accuracy": 0.08,
                            "can_fire_while_moving": true
                        }
                    }
                }
            }
        }
    },
    "cultures": {
        "classical": {
            "carthaginian": {
                "display_name": "Helenic",
                "default_color": "#8e44ad",
                "banner": "tanit",
                "banned_units": [
                    "archers",
                    "heavy_horse_archers",
                    "immortals",
                    "kontos_lancers",
                    "legionaries",
                    "naked_fanatics",
                    "praetorian_guard",
                    "scythed_chariot",
                    "war_chariot"
                ],
                "unit_caps": {
                    "horse_archers": 1
                }
            },
            "gaul": {
                "display_name": "Barbarian",
                "default_color": "#3a7d44",
                "banner": "boar",
                "banned_units": [
                    "archers",
                    "catapult",
                    "heavy_horse_archers",
                    "immortals",
                    "kontos_lancers",
                    "legionaries",
                    "praetorian_guard",
                    "sacred_band",
                    "scythed_chariot",
                    "shock_cavalry",
                    "skirmishers",
                    "war_elephant"
                ],
                "unit_caps": {
                    "war_chariot": 2
                }
            },
            "persian": {
                "display_name": "Eastern",
                "default_color": "#e6b800",
                "banner": "winged_sun",
                "banned_units": [
                    "heavy_horse_archers",
                    "kontos_lancers",
                    "legionaries",
                    "naked_fanatics",
                    "praetorian_guard",
                    "sacred_band",
                    "war_chariot",
                    "war_elephant"
                ],
                "unit_caps": {
                    "archers": 2,
                    "spearmen": 2,
                    "swordsmen": 2
                }
            },
            "roman": {
                "display_name": "Heavy Infantry",
                "default_color": "#b22222",
                "banner": "eagle",
                "banned_units": [
                    "heavy_horse_archers",
                    "horse_archers",
                    "immortals",
                    "kontos_lancers",
                    "naked_fanatics",
                    "sacred_band",
                    "scythed_chariot",
                    "war_chariot",
                    "war_elephant"
                ],
                "unit_caps": {
                    "melee_cavalry": 2
                }
            },
            "steppe": {
                "display_name": "Nomadic",
                "default_color": "#5d4037",
                "banner": "horsetail",
                "banned_units": [
                    "battering_ram",
                    "catapult",
                    "immortals",
                    "legionaries",
                    "naked_fanatics",
                    "praetorian_guard",
                    "sacred_band",
                    "scythed_chariot",
                    "swordsmen",
                    "war_chariot",
                    "war_elephant"
                ],
                "unit_caps": {
                    "skirmishers": 2,
                    "spearmen": 2
                }
            }
        },
        "napoleonic": {
            "austrian": {
                "display_name": "Austrian Empire",
                "default_color": "#fdd835",
                "banner": "habsburg_eagle",
                "banned_units": [],
                "unit_caps": {
                    "dragoons": 2,
                    "riflemen": 1
                }
            },
            "british": {
                "display_name": "British Empire",
                "default_color": "#c0392b",
                "banner": "union_jack",
                "banned_units": [
                    "lancers"
                ],
                "unit_caps": {}
            },
            "french": {
                "display_name": "French Empire",
                "default_color": "#1565c0",
                "banner": "tricolor",
                "banned_units": [
                    "militia"
                ],
                "unit_caps": {}
            },
            "prussian": {
                "display_name": "Kingdom of Prussia",
                "default_color": "#37474f",
                "banner": "iron_cross",
                "banned_units": [],
                "unit_caps": {
                    "militia": 2
                }
            },
            "russian": {
                "display_name": "Russian Empire",
                "default_color": "#2e7d32",
                "banner": "double_eagle",
                "banned_units": [],
                "unit_caps": {
                    "riflemen": 1
                }
            }
        },
        "ww2": {
            "us_army": {
                "display_name": "United States Army",
                "default_color": "#2e7d32",
                "banner": "stars_and_stripes",
                "banned_units": [],
                "unit_caps": {}
            },
            "wehrmacht": {
                "display_name": "Wehrmacht",
                "default_color": "#37474f",
                "banner": "balkenkreuz",
                "banned_units": [],
                "unit_caps": {}
            }
        }
    }
}
